import { z } from 'zod';
import { RowVersionSchema } from '../common/row-version.js';
// Response schemas for the site-types feature. Field-exposure rule (ANATOMY §L7):
// the list row carries EVERY field a site-type has — there is no detail endpoint
// (the edit drawer pre-fills from the row). `license_tier_code` is a code of the
// global tier CATALOGUE (data — a sysadmin adds tiers, ADR-055): a string the FK
// guarantees, named by the list's own `tiers`.
// ── GET /api/projects/:projectId/site-types — list row ──────────────────────
export const SiteTypeListItemSchema = z
    .object({
    row_version: RowVersionSchema,
    id: z.number().int(),
    name: z.string().max(32),
    license_tier_code: z.string(),
    is_disabled: z.boolean(),
    display_order: z.number().int(),
})
    .strict();
// The tiers the list's page needs: the ones the project INCLUDES (the field offers
// them), in the catalogue's order — `included: false` is defensive (a site type's key
// on the included pair keeps its tier included). Names are the catalogue's DATA.
// The seats belong to the TIER, said once per tier: the site form's type picker lists
// the types under their tier as headings ("Simple · 3 seats free").
export const SiteTypeTierSchema = z
    .object({
    code: z.string(),
    name: z.string(),
    /** The tier's cap on a site's active power systems — null = unbounded. */
    max_active_power_systems: z.number().int().nullable(),
    included: z.boolean(),
    /** The tier's LIVE free seats on a prepaid project — purchased minus the seats its operational sites hold (derived
     *  like the activation seat gate, ADR-055; never stored; a tier without a seat row has none); `null` = not
     *  seat-capped (an esco subscription). Zero warns in the form and never blocks a draft — `NO_SEATS` at activation
     *  stays the gate. */
    seats_free: z.number().int().nonnegative().nullable(),
})
    .strict();
export const SiteTypesListResponseSchema = z
    .object({ items: z.array(SiteTypeListItemSchema), tiers: z.array(SiteTypeTierSchema) })
    .strict();
// ── POST create — minimal id (FE refetches the list) ────────────────────────
export const CreatedSiteTypeResponseSchema = z.object({ id: z.number().int() }).strict();
